import React, { memo } from "react";
import Cursor from "./Cursor";
import { usePosition } from "./state/position";
function PositionCursor({
  buffering
}) {
  const position = usePosition();
  return /*#__PURE__*/React.createElement(Cursor, {
    top: 0,
    color: "primary",
    position: position,
    animation: buffering && "blink"
  });
}
export default /*#__PURE__*/memo(PositionCursor);
//# sourceMappingURL=PositionCursor.js.map